module.exports = __webpack_public_path__ + "img/beautify4.29d303f2.webp";